import { Contact } from '../types/crm';

export const crmData: Contact[] = [
  {
    id: '1',
    statut: 'Pas encore contacté',
    prenom: 'Thomas',
    nom: 'Dubois',
    email: 'thomas.dubois@techinnovation.fr',
    phone: '+33 1 42 86 25 45',
    linkedin: 'https://linkedin.com/in/thomas-dubois',
    entreprise: 'Tech Innovation',
    jobTitle: 'Directeur Commercial',
    secteur: 'Technologies',
    effectif: '51-200',
    zoneGeographique: 'France',
    estQualifie: null,
    dateCreation: '2024-03-01T10:00:00',
    dateMiseAJour: '2024-03-01T10:00:00',
  },
  {
    id: '2',
    statut: 'Contacté',
    prenom: 'Marie',
    nom: 'Laurent',
    email: 'marie.laurent@digitalsolutions.com',
    phone: '+33 4 76 92 18 37',
    linkedin: 'https://linkedin.com/in/marie-laurent',
    entreprise: 'Digital Solutions',
    jobTitle: 'CEO',
    secteur: 'Services Numériques',
    effectif: '11-50',
    zoneGeographique: 'France',
    estQualifie: true,
    dateCreation: '2024-02-15T14:30:00',
    dateMiseAJour: '2024-03-05T09:15:00',
  },
  {
    id: '3',
    statut: 'Contacté',
    prenom: 'Alexandre',
    nom: 'Martin',
    email: 'alexandre.martin@globalcorp.eu',
    phone: '+32 2 123 45 67',
    linkedin: 'https://linkedin.com/in/alexandre-martin',
    entreprise: 'Global Corp',
    jobTitle: 'Directeur Marketing',
    secteur: 'Industrie',
    effectif: '1001-5000',
    zoneGeographique: 'Europe',
    estQualifie: null,
    dateCreation: '2024-02-20T11:00:00',
    dateMiseAJour: '2024-03-10T16:45:00',
  },
  {
    id: '4',
    statut: 'Contacté',
    prenom: 'Sophie',
    nom: 'Petit',
    email: 'sophie.petit@retailplus.fr',
    phone: '+33 5 61 34 78 92',
    linkedin: 'https://linkedin.com/in/sophie-petit',
    entreprise: 'Retail Plus',
    jobTitle: 'Responsable Digital',
    secteur: 'Commerce',
    effectif: '201-500',
    zoneGeographique: 'France',
    estQualifie: true,
    dateCreation: '2024-02-10T09:00:00',
    dateMiseAJour: '2024-03-15T11:30:00',
  },
  {
    id: '5',
    statut: 'Contacté',
    prenom: 'Pierre',
    nom: 'Moreau',
    email: 'pierre.moreau@financepro.com',
    phone: '+41 22 789 56 34',
    linkedin: 'https://linkedin.com/in/pierre-moreau',
    entreprise: 'Finance Pro',
    jobTitle: 'CFO',
    secteur: 'Finance',
    effectif: '501-1000',
    zoneGeographique: 'Europe',
    estQualifie: false,
    dateCreation: '2024-02-05T15:00:00',
    dateMiseAJour: '2024-03-12T14:20:00',
  },
]; 